import React from "react";
import { usePlateEditorRef } from "@udecode/plate-core";
import { insertLatex } from "../../node";
import { ToolbarButton, ToolbarButtonProps } from "@udecode/plate-ui-toolbar";

export interface LatexToolbarButtonProps extends ToolbarButtonProps {}

export const LatexToolbarButton = (props: LatexToolbarButtonProps) => {
    const editor = usePlateEditorRef()!;

    return (
        <ToolbarButton
            onMouseDown={async (event) => {
                if (!editor) return;

                event.preventDefault();

                let latexString = "";

                insertLatex(editor, latexString);
            }}
            {...props}
        />
    );
};
